import { Bygningsdetaljer, UserInput } from '../../../../../../types/registration/userInput';
import { JaNeiVetIkke } from '../../../../../../components/registering/utils/registerEnums';
import { OmBoligenFormData } from '../types';

import { updateEtasjer } from './etasjeUtils';

const detaljeringsstegDefault = {
  bygningsform: false,
  energibruk: false,
  vegger: false,
  vinduer: false,
  gulv: false,
  lekkasjetall: false,
  solceller: false,
  takkonstruksjon: false,
  ytterdorer: false
};

export const fromUserInputToFormData = ({
  userInput,
  registreringId
}: {
  userInput?: UserInput;
  registreringId?: string;
}) => {
  const byggdetaljer = userInput?.bygningsdetaljer;

  const formData: OmBoligenFormData = {
    registreringId: registreringId,
    detaljeringssteg: userInput?.detaljeringssteg ?? detaljeringsstegDefault,
    kommunenummer: userInput?.kommunenummerForLokaltKlima,
    bygginfo: {
      byggtype: byggdetaljer?.byggType,
      year: byggdetaljer?.byggAr,
      floors: byggdetaljer?.antallEtasjerUnntattKjeller,
      area: byggdetaljer?.totalBRA,
      heatedArea: byggdetaljer?.totalOppvarmetBRA,
      totalOppvarmetBraBygning: byggdetaljer?.totalOppvarmetBraBygning,
      hasBasement:
        byggdetaljer?.harBoligenKjeller === undefined
          ? undefined
          : byggdetaljer?.harBoligenKjeller
            ? JaNeiVetIkke.Ja
            : JaNeiVetIkke.Nei,
      basementAdjoiningRoom: byggdetaljer?.tilliggendeRomGulvIForsteEtasje,
      isHeatedBasement:
        // When there is no basement, keep the GUI value undefined even if
        // heleEllerDelerAvKjellerErOppvarmet is stored as false deeper in the stack.
        byggdetaljer?.harBoligenKjeller === false ||
        byggdetaljer?.heleEllerDelerAvKjellerErOppvarmet === undefined
          ? undefined
          : byggdetaljer?.heleEllerDelerAvKjellerErOppvarmet
            ? JaNeiVetIkke.Ja
            : JaNeiVetIkke.Nei,
      material: byggdetaljer?.konstruksjonsmateriale,
      horizontalPlacement: byggdetaljer?.plasseringAvEnhetIByggHorisontalt,
      verticalPlacement: byggdetaljer?.plasseringAvEnhetIByggVertikalt
    }
  };
  return formData;
};

export const formDataToUserInput = (data: OmBoligenFormData, userInput: UserInput): UserInput => {
  // Get data filled in form
  const formData = {
    byggAr: data?.bygginfo?.year,
    byggType: data?.bygginfo?.byggtype,
    totalBRA: data?.bygginfo?.area,
    totalOppvarmetBRA: data?.bygginfo?.heatedArea,
    totalOppvarmetBraBygning: data?.bygginfo?.totalOppvarmetBraBygning,
    tilliggendeRomGulvIForsteEtasje: data?.bygginfo?.basementAdjoiningRoom,
    plasseringAvEnhetIByggVertikalt: data?.bygginfo?.verticalPlacement,
    plasseringAvEnhetIByggHorisontalt: data?.bygginfo?.horizontalPlacement,
    konstruksjonsmateriale: data?.bygginfo?.material,
    harBoligenKjeller:
      data?.bygginfo?.hasBasement === undefined
        ? undefined
        : data?.bygginfo?.hasBasement === JaNeiVetIkke.Ja,
    heleEllerDelerAvKjellerErOppvarmet:
      data?.bygginfo?.hasBasement === JaNeiVetIkke.Nei
        ? false
        : data?.bygginfo?.isHeatedBasement === undefined
          ? undefined
          : data?.bygginfo?.isHeatedBasement === JaNeiVetIkke.Ja,
    antallEtasjerUnntattKjeller: data?.bygginfo?.floors
  };

  // Preserve detaljeringssteg from previous userInput if not explicitly provided in form data
  // (detaljeringssteg is not a form field in OmBoligen, so it won't be in the submitted data)
  const detaljeringssteg = data?.detaljeringssteg ?? userInput?.detaljeringssteg ?? detaljeringsstegDefault;

  const bygningsdetaljer: Bygningsdetaljer = {
    ...userInput.bygningsdetaljer,
    ...formData
  };

  const etasjerFromUserInput = userInput.bygningsdetaljer.etasjer;

  // If undefined, there is no basement and therefore false;
  const hasHeatedBasementFromUserInput = !!userInput.bygningsdetaljer.heleEllerDelerAvKjellerErOppvarmet;

  // This is a hack to generate floors in the client. This should be moved to backend.
  bygningsdetaljer.etasjer = updateEtasjer(etasjerFromUserInput, hasHeatedBasementFromUserInput, data);

  const updateUserInput: UserInput = {
    ...userInput,
    bygningsdetaljer,
    detaljeringssteg,
    kommunenummerForLokaltKlima: data.kommunenummer
  };

  return updateUserInput;
};
